<h1 class="pb-5">{{ 'PHASES.title' | translate: { count: 0 } }}</h1>
<app-cards-basic title="{{ 'PHASES.list' | translate:{ count: 0 } }}" [loading]="isLoading">

  @defer {
    <!-- Analysis Period List -->
    <mat-list>
      <mat-nav-list class="py-2">
        @for (phase of phaseListData; track phase) {
          <a mat-list-item (click)="editPhase(phase)" class="list-border-bottom py-2">
            <span matListItemTitle>{{ phase.translations[currentLanguage].title }}</span>
            <span matListItemLine>{{ phase.start_date }} – {{ phase.end_date }}</span>
            <button mat-icon-button (click)="confirmDelete(phase.id, $event)" aria-label="Delete" class="trailing-end-button">
              <mat-icon>
                <span class="material-symbols-outlined">delete</span>
              </mat-icon>
            </button>
          </a>
        }
      </mat-nav-list>
    </mat-list>

    <!-- Analysis Period Form -->
    @if (isFormVisible) {
      <form #periodForm="ngForm" (ngSubmit)="savePhase()" class="pt-3">
        <div class="row">
          <mat-form-field appearance="fill" class="col">
            <mat-label>{{ 'COMMON.title_en' | translate }}</mat-label>
            <input matInput
                   required
                   [(ngModel)]="phase.translations['en'].title"
                   name="PhaseTitleEnglish"
                   #PhaseTitleEnglish="ngModel">
          </mat-form-field>

          <mat-form-field appearance="fill" class="col">
            <mat-label>{{ 'COMMON.title_de' | translate }}</mat-label>
            <input matInput
                   required
                   [(ngModel)]="phase.translations['de'].title"
                   name="PhaseTitleGerman"
                   #PhaseTitleGerman="ngModel">
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="fill" class="col">
            <mat-label>{{ 'COMMON.description' | translate }} ({{ 'COMMON.english' | translate }})</mat-label>
            <input matInput
                   required
                   [(ngModel)]="phase.translations['en'].description"
                   name="PhaseDescriptionEnglish"
                   #PhaseDescriptionEnglish="ngModel">
          </mat-form-field>

          <mat-form-field appearance="fill" class="col">
            <mat-label>{{ 'COMMON.description' | translate }} ({{ 'COMMON.german' | translate }})</mat-label>
            <input matInput
                   required
                   [(ngModel)]="phase.translations['de'].description"
                   name="PhaseDescriptionGerman"
                   #PhaseDescriptionGerman="ngModel">
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="fill" class="col">
            <mat-label>{{ 'PERIODS.start_date' | translate }}</mat-label>
            <input matInput [matDatepicker]="startDatePicker"
                   required
                   [(ngModel)]="phase.start_date"
                   name="StartDate"
                   #startDate="ngModel">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col">
            <mat-label>{{ 'PERIODS.end_date' | translate }}</mat-label>
            <input matInput [matDatepicker]="endDatePicker"
                   required
                   [(ngModel)]="phase.end_date"
                   name="EndDate"
                   #endDate="ngModel">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-checkbox name="hasDashedLine" [(ngModel)]="phase.has_dashed_line">Marked as Dashed Line in Chart</mat-checkbox>
        </div>

        <button mat-button
                color="primary"
                type="button"
                class="bp-button"
                (click)="toggleFormVisibility()">
          {{ 'ACTIONS.cancel' | translate }}
        </button>
        <button mat-button
                color="primary"
                type="submit"
                class="bp-button"
                [disabled]="!periodForm.valid" >
          {{ 'ACTIONS.save' | translate }}
        </button>
      </form>

    } @else {
      <button mat-flat-button
              color="primary"
              (click)="toggleFormVisibility()"
              class="mt-3 bp-button">
        {{ 'PHASES.create' | translate }}
      </button>
    }

  } @loading (minimum 800ms) {
    <mat-spinner diameter="30" strokeWidth="1" style="margin:0 auto;"></mat-spinner>
  }
</app-cards-basic>
